import React, { useRouter } from "next/router";
import { Suspense, useCallback } from "react";
import { isDateExpired, isEmpty } from "../../utils/common";
import Breadcrum from "../common/breadcrum";
import { tailwindClasses } from "./tailwindClasses";

const LightBox = dynamic(() => import("../common/light-box"), { ssr: false });
const AdvertisementBanner = dynamic(() => import("../BannerAdd"), {
  ssr: false,
});

import dynamic from "next/dynamic";
import CachedImage from "../../common/cachedImage";
import { Add, GalleryWrap, Gwrap } from "../../common/commonStyled";
import EyeIcon from "../../common/EyeIcon";
import HowToReach from "./howToReach";
import { LocationInfo } from "./style";

export default function CityDetailsComp({ data = {} }) {
  const { locationInfo, featuredImage, pointers = [] } = data;
  const { tag, coming_soon, main_wrap, h1_style, city_brief_wrap } =
    tailwindClasses;
  const router = useRouter();

  const redirectPage = useCallback(
    (link) => {
      if (link) {
        router.push(`/${router.asPath}/hotels/${link}`);
      }
    },
    [router]
  );

  const goDetails = (link) => {
    return () => {
      if (link) {
        router.push(link);
      }
    };
  };

  const city = router.query.city;
  if (data?.title === undefined) {
    return (
      <main className={coming_soon}>
        <div>Coming soon!</div>
      </main>
    );
  }

  return (
    <main className={main_wrap}>
      <Gwrap>
        <div className="flex main-wrapper flex-wrap sm:flex-nowrap">
          {featuredImage?.[0].src ? (
            <GalleryWrap
              className="pd-[36px] lg:flex-[0_0_720px]"
              imageLen={(featuredImage || []).length}
            >
              <LightBox featuredImage={featuredImage} />
            </GalleryWrap>
          ) : (
            <div className="h-[67px]"></div>
          )}
          <div className="pl-[8px]">
            <h1 className={h1_style}>{data?.title}</h1>
            {data?.city_brief && (
              <article dangerouslySetInnerHTML={{ __html: data?.city_brief }} />
            )}
          </div>
        </div>
      </Gwrap>
      <div
        className={` ${
          featuredImage ? "bg-[#384148] w-full" : "pt-[16px]"
        }  md:flex justify-between align-center`}
      >
        <Breadcrum className="main-wrapper  text-[#fff] !p-[4px_0] !w-full" />
      </div>
      <div className="md:flex main-wrapper md:gap-[1%] items-start">
        <div className={city_brief_wrap}>
          <div>
            {data?.places?.map((item, i) => {
              return (
                <div
                  key={i}
                  role="button"
                  tabIndex={0}
                  onClick={goDetails(item?.link)}
                  className={item?.link ? "cursor-pointer" : "cursor-default"}
                >
                  <div className="flex items-start flex-wrap ">
                    <h2 className={`pt-[16px] border-0 pb-[12px] relative`}>
                      <span className="border-l-4 border-[#58A4AE] pl-[8px]">
                        {i + 1}.&nbsp;
                      </span>
                      <span className="text-[#58A4AE] bold">
                        {item?.title}
                        {item?.tag && (
                          <i
                            className={`${tag} tag-${item?.tag
                              .split(" ")
                              .join("-")
                              .toLowerCase()}`}
                          >
                            {item?.tag}
                          </i>
                        )}
                      </span>
                    </h2>
                  </div>
                  <Suspense fallback={<div>Loading...</div>}>
                    <div
                      className={`article${i} flex flex-wrap mb-[12px] sm:flex-nowrap`}
                    >
                      {item?.img && (
                        <div
                          className={`w-full sm:w-[360px] flex-[0_0_100%] sm:flex-[0_0_360px] img-border ${
                            i % 2 === 0
                              ? "order-1 pb-[12px] md:pb-[0]"
                              : "order-2"
                          }`}
                        >
                          <CachedImage
                            className={`article-img rounded-[4px]`}
                            width={500}
                            height={500}
                            imageUrl={item?.img}
                            alt={item?.title || "traviya"}
                          />
                        </div>
                      )}
                      <article
                        className={`travel-content text-justify justify-last ${
                          i % 2 === 0
                            ? "order-2 md:pl-[16px]"
                            : "order-1 md:pr-[16px]"
                        }`}
                        dangerouslySetInnerHTML={{ __html: item?.description }}
                      />
                    </div>
                    {item?.link && (
                      <EyeIcon className="ml-[8px]" placeName={item?.title} />
                    )}
                  </Suspense>
                  {(item?.adds || [])?.map((data) => {
                    return (
                      <>
                        {!isDateExpired(data?.add_expiry) && (
                          <Add
                            onClick={() => redirectPage(data.link)}
                            dangerouslySetInnerHTML={{
                              __html: data?.add_text,
                            }}
                          />
                        )}
                      </>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {data?.how_to_reach && (
        <h3 className="flex tex-[32px] main-wrapper pt-[24px] pb-[16px] border-0 bold-italic">
          {data?.how_to_reach}
        </h3>
      )}
      <HowToReach
        byAir={data?.reach_by_air}
        byCar={data?.reach_by_road}
        byRail={data?.reach_by_rail}
      />
      <LocationInfo>
        {locationInfo?.map((item, i) => {
          return (
            <div key={i} className="main-wrapper">
              <span className="label">{item.label}:&nbsp;</span>
              <span className="value">{item.value}</span>
            </div>
          );
        })}
      </LocationInfo>
      {!isEmpty(city?.full_page_add) && (
        <AdvertisementBanner citySlug={data.full_page_add} />
      )}
    </main>
  );
}
